// Mode clair / sombre : trois états sur le bouton de l'en-tête, en boucle : automatique → clair → sombre → automatique.
// Automatique = préférence de l'appareil (réglage « auto ») ou l'heure (réglage « horaire ») ; rien n'est mémorisé.
// Clair ou sombre = choix du visiteur, mémorisé (localStorage ; sessionStorage en mode horaire, l'heure reprend la main à la prochaine visite).
// Inactif si le réglage de thème impose un mode. L'état courant est porté par data-choix sur <html> (absent = automatique) ; le CSS y accroche l'icône.
const CLE = "mz-mode";

export default function mode() {
    const html = document.documentElement;
    const bouton = document.getElementById("mode-toggle");
    if (!bouton || html.dataset.mode === "fixe") return;

    const horaire = html.dataset.mode === "horaire";
    const systeme = matchMedia("(prefers-color-scheme: dark)");
    const stockage = horaire ? sessionStorage : localStorage;
    const lire = () => { try { const m = stockage.getItem(CLE); return m === "dark" || m === "light" ? m : null; } catch (e) { return null; } };
    const selonHeure = () => { const h = new Date().getHours(); return (h >= 20 || h < 7) ? "dark" : "light"; };
    const automatique = () => (horaire ? selonHeure() : (systeme.matches ? "dark" : "light"));

    const LIBELLES = {
        auto: (t) => `Mode d'affichage automatique (${t === "dark" ? "sombre" : "clair"} en ce moment). Passer en mode clair`,
        light: () => "Mode clair choisi. Passer en mode sombre",
        dark: () => "Mode sombre choisi. Revenir au mode automatique",
    };

    function appliquer(choix) {
        if (choix) { html.dataset.theme = choix; html.dataset.choix = choix; }
        else { delete html.dataset.choix; if (horaire) html.dataset.theme = selonHeure(); else delete html.dataset.theme; }
        const etat = choix || "auto";
        bouton.setAttribute("aria-label", LIBELLES[etat](html.dataset.theme || automatique()));
        bouton.setAttribute("aria-pressed", String(etat === "dark"));
    }

    bouton.addEventListener("click", () => {
        const etat = html.dataset.choix || "auto";
        const suivant = etat === "auto" ? "light" : etat === "light" ? "dark" : null;
        try { if (suivant) stockage.setItem(CLE, suivant); else stockage.removeItem(CLE); } catch (e) { /* stockage indisponible */ }
        appliquer(suivant);
    });

    systeme.addEventListener("change", () => { if (!lire()) appliquer(null); });
    if (horaire) setInterval(() => { if (!lire()) appliquer(null); }, 60000);

    appliquer(lire());
}
